import _ from 'lodash'
import type {SingleComponentPluginFunction} from '../../types'
import {isInnerElementsMapWrapper} from './common'

const unwrapInnerElements = (obj: any): void => {
    _.forOwn(obj, (val: any, key: string) => {
        if (_.isArray(val)) {
            for (const item of val) {
                if (_.isPlainObject(item)) {
                    unwrapInnerElements(item)
                }
            }
            return
        }

        // If the current value is an InnerElementsMap, unwrap it and replace the
        // current value with the inner elements map directly.
        if (isInnerElementsMapWrapper(val)) {
            obj[key] = val.innerElements
            unwrapInnerElements(obj[key])
            return
        }

        if (_.isPlainObject(val)) {
            unwrapInnerElements(val)
        }
    })
}

export const pack: SingleComponentPluginFunction = component => unwrapInnerElements(component)
